// Contexto para anmazenar dados do ID do AutoComplete escolhido

import React, { createContext, useState } from "react";

export const TipoConsultaIdContext = createContext()
export const TipoConsultaDescrContext = createContext()

export const TipoConsultaContextProvider = ({ children }) => {
    const [tipoConsultaIdContext, setTipoConsultaIdContext] = useState('')
    const [tipoConsultaDescrContext, setTipoConsultaDescrContext] = useState('')

    return (
        <TipoConsultaIdContext.Provider value={{ tipoConsultaIdContext, setTipoConsultaIdContext }}>
            <TipoConsultaDescrContext.Provider value={{ tipoConsultaDescrContext, setTipoConsultaDescrContext }}>
                {children}
            </TipoConsultaDescrContext.Provider>
        </TipoConsultaIdContext.Provider>
    )
}